let ContentServerClient = require("./../ContentServerClient.js");

// class for helper functions for reading circuits data
class CircuitsUtil {

	constructor(){
        this.getSource = this.getSource.bind(this);
        this.getViewUrl = this.getViewUrl.bind(this);
        this.formatName = this.formatName.bind(this);
        this.checkMarkForDeleted = this.checkMarkForDeleted.bind(this);
        this.getFootprintThumbnail = this.getFootprintThumbnail.bind(this);
        this.getMostRecentVersion = this.getMostRecentVersion.bind(this);
        this.getPluralFromResourceType = this.getPluralFromResourceType.bind(this);
        this.modelTranslationSuccess = this.modelTranslationSuccess.bind(this);
    }

    getStatusLibrary(savePoints){
        if(!savePoints) return "failed";
        return savePoints.reduceRight( (accum, {type, status = ""}) => {
            if(accum === "failed") {
                accum = type;
                if(type === "import"){ accum = status }
            }
            return accum;
        }, "failed");
    }


    getLastImportVersionIndex(resource, successfulOnly = false){
        if(!resource.save_points) return -1;
        let savePoints = resource.save_points;
        for(let i = savePoints.length - 1; i >= 0; i--){
            if(savePoints[i].type == "import"){
                if (successfulOnly && savePoints[i].status_details !== "Successful Import") continue;

                return i;
            }
        }
        return -1;
    }

    hasSuccessfulEagleImport(resource){
        return this.getMostRecentVersion(resource) != -1;
    }


	getMostRecentVersion(resource){
        if(!resource.save_points) return -1;
        let savePoints = resource.save_points;
        for(let i = savePoints.length - 1; i >= 0; i--){
            if(savePoints[i].type == "savedSnapshot"){
                return savePoints[i].version;
            }
        }
        return -1;
    }

    getSource(resource){
        if(!resource.save_points) return "";
        var savePoints = resource.save_points;
        let sourcePicked = false;
        return savePoints.reduceRight( (accum, {type, source}) => {
                    if(!sourcePicked && type === "import") {
                        accum = source.files.reduceRight((inAccum, {source}) => {
                            if(/(file|http:|https:)/gi.test(source)){
                                inAccum = source;
                                sourcePicked = true;
                            }
                            return inAccum;
                        }, "");
                    }
                    return accum;
                }, "");
    }

    getFootprintThumbnail(handleError, resource){
      if (typeof resource === "object" && "thumbnail2d" in resource) {
          return Promise.resolve({thumbnail: resource.thumbnail2d, name: resource.name, summary: resource.summary});
      } else {
          return ContentServerClient.getColabDoc(handleError, "packages", resource)
              .then(({body: {footprintInstances: [{ancestor: {$asset: {id: footprintId}}}]}}) => ({footprintId}))
              .then(({footprintId}) => ContentServerClient.getFile(handleError, `/footprints/${footprintId}`))
              .then(source => ({thumbnail: source.thumbnail, name: source.name, summary: source.summary}))
      }
    }

    // Other
    ////////////////////////
    getViewUrl(type, id, name){
        return `/${type}/${id}-${this.formatName(name)}`
    }

    formatName(name){
        return name.replace(/ /g,"-").replace("/","%2F");
    }

    getPluralFromResourceType(type){
        switch(type){
            case "library":
                return "libraries";
            case "component":
                return "components";
            case "package":
                return "packages";
            case "footprint":
                return "footprints";
            case "symbol":
                return "symbols";
            case "3dmodel":
                return "3dmodels"
        }
    }

    checkMarkForDeleted(results, isTrash){
        // count how many assets are in the tagged for removal state
        let deletedList = results.filter(item => 
            (item.deleted === true && !isTrash) || (item.deleted === false && isTrash)
        );
        // if some of these cards on this page have been tagged for removal,
        // refresh the page after a few second delay
        if(deletedList.length > 0){
            return true;
        }
        return false;
    } 


    modelTranslationSuccess(resource){
        let objTranslaing = resource.objStatus === "translating";
				let stepTranslaing = resource.f3dStatus === "translating";
				let f3dTranslaing = resource.stepStatus === "translating";
				let notStarted = !resource.objStatus && !resource.f3dStatus && !resource.stepStatus;
				let isTranlating = objTranslaing || stepTranslaing || f3dTranslaing || notStarted
        return !this.modelTranslationFailed(resource) && !isTranlating;
    }

    modelTranslationFailed(resource){
        let objFail = resource.objStatus === "failed";
        let f3dFail = resource.f3dStatus === "failed";
				let stepFail = resource.stepStatus === "failed";

        return objFail || f3dFail || stepFail || resource.fail_cause;
    }
		
		
    modelTranslationWarning(resource){
        let objFail = resource.objStatus === "failed";
				let stepSuccess = resource.stepStatus === "complete";

        return objFail && stepSuccess;
    }
		
		modelHasXref(resource){
				return resource.hasXrefs;
		}

    getLibraryQueryFields() {
        return "qf=name,description,summary,tags&cf=name,description"
    }

    isLibraryQueryEndpoint(url) {
      return /^\/(explore\/)?libraries\?/.test(url)
    }
}

module.exports = new CircuitsUtil();
